import { render, staticRenderFns } from "./TerminalParcels/TerminalParcels.html?vue&type=template&id=4c121107&scoped=true&external"
import script from "./TerminalParcels.vue?vue&type=script&lang=js"
export * from "./TerminalParcels.vue?vue&type=script&lang=js"
import style0 from "./TerminalParcels.vue?vue&type=style&index=0&id=4c121107&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c121107",
  null
  
)

export default component.exports